import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_menu_contact",
  "use": "icon_menu_contact-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_menu_contact\"><path d=\"M2.434 6.318l.97.971L7.29 3.405l-.97-.971L8.751 0s1.163 1.07 1.242 1.919c.104 1.136-1.098 3.201-2.986 5.089-1.888 1.888-3.953 3.09-5.09 2.986C1.07 9.915 0 8.752 0 8.752l2.434-2.434zM.632 4H0c0-2.206 1.794-4 4-4v.632A3.372 3.372 0 0 0 .632 4M2.75 5H2c0-1.654 1.346-3 3-3v.75C3.76 2.75 2.75 3.76 2.75 5\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol